import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { MdOutlineDeleteOutline } from "react-icons/md";
import { useEffect, useReducer, useState } from "react";
import Paper from "@mui/material/Paper";
import { Button, Modal, Box, Checkbox } from "@mui/material";
import { produce } from "immer";
import dayjs from "dayjs";
import BillsModal from "../../../components/clinic/BillsModal";
import DeleteModal from "../../../components/clinic/DeleteModal";
import {
  AMOUNT_AFTER_DUE,
  AMOUNT_DUE,
  AMOUNT_PAID,
  CHANGE_MID,
  CLEAR_DATA,
  CLEAR_ERROR,
  DATE_PAID,
  DELETE_DATA,
  DUE_DATE,
  EDIT_DATA,
  GET_TOKEN,
  LOADING,
  PULLED_DATA,
  PUSH_DATA,
  SET_EDIT,
  SET_ID,
  SET_NAME,
  SET_RELOAD,
  TOKEN_NAME,
} from "../../../components/clinic/Constant";
import globalVariables from "../../../globalVariables";
import { useMediaQuery } from "react-responsive";
import classNames from "classnames";

const SET_MODAL_ON = "set-modal-on";
const SET_MODAL_OFF = "set-modal-off";
const SET_EXTT_MODAL_ON = "set-exit-modal-on";
const SET_EXTT_MODAL_OFF = "set-exit-modal-off";

const reducer = (state, action) => {
  switch (action.type) {
    case SET_MODAL_ON:
      state.showModal = true;
      return;

    case SET_MODAL_OFF:
      state.showModal = false;
      state.setError = false;
      return;

    case SET_NAME:
      state.name = action.payload;
      return;

    case AMOUNT_DUE:
      state.amountDue = action.payload;
      return;

    case AMOUNT_AFTER_DUE:
      state.amountAfterDue = action.payload;
      return;

    case DUE_DATE:
      state.dueDate = action.payload;
      return;

    case DATE_PAID:
      state.datePaid = action.payload;
      return;

    case AMOUNT_PAID:
      state.amountPaid = action.payload;
      return;

    case PUSH_DATA:
      if (state.token) {
        if (
          action.payload.item == null ||
          action.payload.amountdue == null ||
          action.payload.amountafterdue == null
        ) {
          state.setError = true;
          return;
        }
        try {
          fetch(`${globalVariables.WEB_ADDRESS_PORT}/?type=addbill`, {
            method: "POST",
            headers: {
              token: state.token,
              "ngrok-skip-browser-warning": true, 
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              name: action.payload.item,
              amountdue: action.payload.amountdue,
              amountafterdue: action.payload.amountafterdue,
              duedate: action.payload.duedate,
              datepaid: action.payload.datepaid,
              amountpaid: action.payload.amountpaid,
            }),
          })
            .then((response) => {
              if (!response.ok) {
                throw new Error("Network response was not ok");
              }
              return response.json();
            })
            .then(() => {
              console.log("Added");
            })
            .catch((error) => {
              console.error("Error fetching data:", error);
            });
        } catch (error) {
          console.error("Error at: ", error);
        }

        state.showModal = false;
        state.reload = true;
      }
      return;

    case CLEAR_DATA:
      state.selectedRow.item = "";
      state.selectedRow.amountdue = "";
      state.selectedRow.amountafterdue = "";
      state.selectedRow.duedate = null;
      state.selectedRow.datepaid = null;
      state.selectedRow.amountpaid = "";
      state.selectedRow.id = null;
      return;

    case CLEAR_ERROR:
      state.setError = false;
      return;

    case GET_TOKEN:
      state.token = action.payload;
      return;

    case SET_EXTT_MODAL_ON:
      state.showExitModal = true;
      return;

    case SET_EXTT_MODAL_OFF:
      state.showExitModal = false;
      return;

    case SET_ID:
      state.id = action.payload;
      return;

    case SET_EDIT:
      state.editMode = true;
      return;

    case LOADING:
      state.loading = action.payload;
      return;

    case CHANGE_MID:
      state.selectedRow.item = action.payload.item;
      state.selectedRow.amountafterdue = action.payload.amountafterdue;
      state.selectedRow.amountdue = action.payload.amountdue;
      state.selectedRow.amountpaid = action.payload.amountpaid;
      state.selectedRow.datepaid = dayjs(action.payload.datepaid);
      state.selectedRow.duedate = dayjs(action.payload.duedate);
      state.selectedRow.id = action.payload.id;
      return;

    case DELETE_DATA:
      if (state.token) {
        try {
          fetch(
            `${globalVariables.WEB_ADDRESS_PORT}/?type=removebill&id=${state.id}`,
            {
              method: "DELETE",
              headers: { "ngrok-skip-browser-warning": true, token: state.token },
            }
          )
            .then((response) => {
              if (!response.ok) {
                throw new Error("Network response was not ok");
              }
              return response.json();
            })
            .then(() => {
              console.log("Deleted");
            })
            .catch((error) => {
              console.error("Error fetching data:", error);
            });
        } catch (error) {
          console.error("Error at: ", error);
        }
        state.showModal = false;
        state.reload = true;
      }
      return;

    case PULLED_DATA:
      state.rows = action.payload;
      return;

    case SET_RELOAD:
      state.reload = action.payload;
      return;

    case EDIT_DATA:
      if (state.token) {
        try {
          fetch(`${globalVariables.WEB_ADDRESS_PORT}/?type=updatebill`, {
            method: "PATCH",
            headers: {
              token: state.token,
              "ngrok-skip-browser-warning": true, 
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              name: action.payload.item,
              amountdue: action.payload.amountdue,
              amountafterdue: action.payload.amountafterdue,
              duedate: action.payload.duedate,
              datepaid: action.payload.datepaid,
              amountpaid: action.payload.amountpaid,
              id: action.payload.id,
            }),
          })
            .then((response) => {
              if (!response.ok) {
                throw new Error("Network response was not ok");
              }
              return response.json();
            })
            .then(() => {
              console.log("Updated");
            })
            .catch((error) => {
              console.error("Error fetching data:", error);
            });
        } catch (error) {
          console.error("Error at: ", error);
        }

        state.showModal = false;
        state.reload = true;
      }
      return;

    default:
      throw new Error("unexpected action type" + action.type + " At BillsPage");
  }
};

function BillsPage({ userType }) {
  const [state, dispatch] = useReducer(produce(reducer), {
    showModal: false,
    showExitModal: false,
    loading: true,
    id: 0,
    rows: [],
    token: "",
    reload: false,
    selectedRow: {
      item: "",
      amountdue: "",
      amountafterdue: "",
      duedate: null,
      datepaid: null,
      amountpaid: "",
      id: null,
    },
  });

  const isPhone = useMediaQuery({ query: "(max-width: 768px)" });
  const textClass = classNames("font-bold", isPhone ? "text-l" : "text-xl");

  const tableStyles = {
    minWidth: isPhone ? '100%' : 650,
    '& .MuiTableCell-root': {
      padding: isPhone ? '8px' : 'default',
      fontSize: isPhone ? '12px' : 'default', // Adjust font size for smaller screens
    },
  };

  function reloadData() {
    const recievedToken = localStorage.getItem(TOKEN_NAME);
    dispatch({ type: GET_TOKEN, payload: recievedToken});
    dispatch({ type: LOADING, payload: true });

    if ((recievedToken && userType === "clinic") || state.reload === true) {
      try {
        fetch(`${globalVariables.WEB_ADDRESS_PORT}/?type=getbill`, {
          method: "GET",
          headers: { token: recievedToken, "ngrok-skip-browser-warning": true, "Content-Type": "application/json" },
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error("Network response was not ok");
            }
            return response.json();
          })
          .then((data) => {
            dispatch({ type: PULLED_DATA, payload: data });
            dispatch({ type: LOADING, payload: false });
            dispatch({ type: SET_RELOAD, payload: false });
          })
          .catch((error) => {
            console.error("Error fetching data:", error);
          });
      } catch (error) {
        console.error("Error at: ", error);
      }
    }
  }

  useEffect(() => {
    reloadData();
  }, [userType, state.reload]);

  const setModal = () => {
    dispatch({ type: SET_MODAL_ON });
  };

  const closeModal = () => {
    dispatch({ type: CLEAR_DATA });
    dispatch({ type: CLEAR_ERROR });
    dispatch({ type: SET_MODAL_OFF });
  };

  const handleEdit = (object) => {
    dispatch({ type: SET_EDIT });
    dispatch({ type: CHANGE_MID, payload: object });
    dispatch({ type: SET_MODAL_ON });
  };

  function handleExitModal(object) {
    dispatch({ type: SET_EXTT_MODAL_ON });
    dispatch({ type: SET_ID, payload: object });
  }

  const closeExitModal = () => {
    dispatch({ type: SET_EXTT_MODAL_OFF });
  };

  if (state.loading) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <div>
        <Button color="secondary" id={"add-bill"} onClick={setModal}>
          Add
        </Button>
        {/* <Button onClick={handlePullChanges}> Refresh </Button> */}
        <BillsModal
          open={state.showModal}
          onClose={closeModal}
          state={state.selectedRow}
          dispatch={dispatch}
          editMode={state.editMode}
          setError={state.setError}
        />
        <DeleteModal
          open={state.showExitModal}
          onClose={closeExitModal}
          dispatch={dispatch}
          id={state.id}
        />
      </div>
      <TableContainer component={Paper}>
        <Table sx={tableStyles} aria-label="simple table">
          <TableHead>
            <TableRow className="bg-[#ac7de8]">
              <TableCell>
                <p className={textClass}>Name</p>
              </TableCell>
              <TableCell align="right">
                <p className={textClass}>Amount Due</p>
              </TableCell>
              <TableCell align="right">
                <p className={textClass}>Amount After Due</p>
              </TableCell>
              <TableCell align="right">
                <p className={textClass}>Due Date </p>
              </TableCell>
              <TableCell align="right">
                <p className={textClass}>Date Paid </p>
              </TableCell>
              <TableCell align="right">
                <p className={textClass}>Amount Paid </p>
              </TableCell>
              <TableCell align="left"> </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {state.rows.map((row) => (
              <TableRow
                key={`key-${row.id}`}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell component="th" scope="row">
                  {row.item && row.item}
                </TableCell>
                <TableCell align="right">
                  {row.amountdue && row.amountdue}
                </TableCell>
                <TableCell align="right">
                  {row.amountafterdue && row.amountafterdue}
                </TableCell>
                <TableCell align="right">
                  {row.duedate && dayjs(row.duedate).format("MM/DD/YYYY")}
                </TableCell>
                <TableCell align="right">
                  {row.datepaid && dayjs(row.datepaid).format("MM/DD/YYYY")}
                </TableCell>
                <TableCell align="right">
                  {row.amountpaid && row.amountpaid}
                </TableCell>
                <TableCell align="left">
                  <div className="flex">
                    <Button onClick={() => handleEdit(row)}> Edit </Button>
                    <MdOutlineDeleteOutline
                      className={
                        "hover:cursor-pointer hover:bg-gray-300 w-7 h-7 ml-2"
                      }
                      onClick={() => handleExitModal(row.id)}
                    />
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}

export default BillsPage;
